/**
 * Convert format date to server
 * @param {number} current value
 * @return {string} new currency
 */

import { isNumber } from "lodash";

function currentcyFormatter(value: number,name="VND") {
  return new Intl.NumberFormat('vi-VN', { style: 'currency', currency:name }).format(value);
}

function convertNumberToString(number: number) {
  return String(number).replace(/(\d)(?=(\d{3})+(\.(\d){0,2})*$)/g, '$1,');
}

function convertNumberFormatShortEN(value: number) {
  return `${new Intl.NumberFormat('en', { notation: 'compact', compactDisplay: 'short' }).format(value)}`;
}

/**
 * Convert amount string or number to number
 * @param number
 * @returns number
 */
function convertAmountStringToNumber(number: any) {
  if(isNumber(number))
    return number;
  return number
    ? Number.isInteger(number)
      ? parseFloat(number)
      : parseFloat(number.replaceAll(',', '').replaceAll('.', '').replaceAll('VND', '').replaceAll(' ', ''))
    : 0;
}

/**
 * Convert rate string or number to number
 * @param number
 * @returns number
 */
function convertRateStringToNumber(number: any) {
  if(isNumber(number))
    return number;
  return number
    ? Number.isInteger(number)
      ? parseFloat(number)
      : parseFloat(number.replaceAll(',', '').replaceAll('.', '').replaceAll('%', '').replaceAll(' ', ''))
    : 0;
}

export {
  currentcyFormatter,
  convertNumberToString,
  convertNumberFormatShortEN,
  convertAmountStringToNumber,
  convertRateStringToNumber
};
